import { render } from "./QuestionSetIndexComponents.vue?vue&type=template&id=2b4d1344"
import script from "./QuestionSetIndexComponents.vue?vue&type=script&lang=js"
export * from "./QuestionSetIndexComponents.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_905a1b4c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__